const VARIANTE_DEFAULT = 'RELIGIOSO';

/**
 * Textos del bloque «Historia y descripción» (bio) según variante de perfil y nombre del catálogo.
 * @param {{ perfilVariante?: string; tipoEntidad?: { nombre?: string; codigo?: string } | null }} p
 * @returns {{ formLabel: string; placeholder: string; helperText: string }}
 */
export function getCofradiaBioHistoriaCopy({ perfilVariante, tipoEntidad }) {
  const v = perfilVariante || VARIANTE_DEFAULT;
  const tipoNombre = tipoEntidad?.nombre != null ? String(tipoEntidad.nombre).trim() : '';
  const tipoMin = tipoNombre ? tipoNombre.toLowerCase() : '';

  if (v === 'AYUNTAMIENTO') {
    return {
      formLabel: 'Historia y descripción',
      placeholder:
        'Contexto del municipio, cultura musical, fiestas locales, colaboración con bandas y eventos institucionales...',
      helperText:
        'Explica cómo encaja la música procesional o las bandas en la vida local. Facilita que las formaciones entiendan vuestras prioridades y calendario.',
    };
  }

  if (v === 'ASOCIACION_CULTURAL') {
    return {
      formLabel: 'Historia y descripción',
      placeholder:
        'Origen de la asociación, fines culturales, proyectos, público objetivo y tipo de colaboraciones con músicos...',
      helperText:
        'Describe la asociación tal como la verán bandas u otros colaboradores: ámbito, actividades y qué esperáis de una colaboración.',
    };
  }

  if (v === 'OTRO') {
    const sujeto = tipoMin || 'entidad';
    return {
      formLabel: 'Historia y descripción',
      placeholder: `Historia, misión y líneas de actuación de tu ${sujeto}...`,
      helperText: `Resume qué hace tu ${sujeto}, a quién sirve y qué debería saber una banda o colaborador antes de contactaros.`,
    };
  }

  // RELIGIOSO (y tipos de entidad religiosa del catálogo)
  const placeholder = tipoMin
    ? `Cuenta la historia de tu ${tipoMin}, tradiciones, cultos y valores...`
    : 'Cuenta la historia de tu cofradía o hermandad, tradiciones, cultos y valores...';
  const helperText = tipoMin
    ? `Describe la historia, el carácter y los valores de tu ${tipoMin} para quien busca música o colaboración.`
    : 'Describe la historia, tradiciones y valores de tu cofradía para quien busca música o colaboración.';

  return {
    formLabel: 'Historia y descripción',
    placeholder,
    helperText,
  };
}
